import { Spacing } from '~/types/ThemeTypes'
import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const tagInputStyleParts = [
  'label',
  'dataContainer',
  'inputContainer',
  'tagContainer',
  'tag',
  'tagCloseButton',
  'errorContainer',
  'guideText',
  'errorText',
] as const

const helpers = createMultiStyleConfigHelpers(tagInputStyleParts)
export const TagInputStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    label: {
      ...textStyles[textStyleKeys.Body3_Bold],
      color: 'fg.default',
    },
    dataContainer: {
      alignItems: 'stretch',
      gap: Spacing._4,
    },
    tagContainer: {
      flexWrap: 'wrap',
    },
    inputContainer: {
      alignItems: 'stretch',
      gap: Spacing._1,
    },
    tagCloseButton: {
      color: 'fg.default',
    },
    errorContainer: {
      alignItems: 'stretch',
      gap: Spacing._0_5,
    },
    guideText: {
      ...textStyles[textStyleKeys.Body4],
      color: 'fg.default',
    },
    errorText: {
      color: 'red.emphasized',
      ...textStyles[textStyleKeys.Body3_Bold],
    },
  },
})

export const useTagInputStyles = () =>
  mergeMultiStyleConfig(TagInputStyle) as MultiStyleType<
    typeof tagInputStyleParts
  >
